import { SIBASI_APPS } from 'src/app/common/model/sibasi-system.model';

export const IndexHTMLDetails: {
  title: string;
  description: string;
  sibasiApp: SIBASI_APPS;
}[] = [
  {
    title: 'Sibasi Electronic Board Management System',
    description:
      'Manage meeting notes, action points, and document annotations seamlessly with our Eboard system. Stay organized and informed with easy access to all meeting-related information.',
    sibasiApp: SIBASI_APPS.EBOARD
  },
  {
    title: 'Monitoring and Evaluation System',
    description:
      'Track and assess project performance with our monitoring and evaluation system. Gain insights through real-time data analysis, performance indicators, and progress reports. Enhance decision-making and project outcomes effectively.',
    sibasiApp: SIBASI_APPS.MONIVAL
  },
  {
    title: 'Efficient Business Management Suite',
    description: `Efficient business management through the best-in-class, #1 business management software tools, including Point of Sale(POS), Customer Relationship Management, On the Go Business Reporting, Employees Management, Inventory Management, Multi-currency, HR System.`,
    sibasiApp: SIBASI_APPS.EBMSUITE
  }
];
